import React from "react";
import { Column, Grid, Row } from "cdk-radial";
import BundleCard from "./BundleCard";

function BundleList({
  apiBundles,
  isSearchText,
  count,
  entity,
  environmentURLs,
  belongsTo,
  apiHomeOnClickHandlers = {},
  existingSolutionDetails,
  disableBuildNow,
  isMsaConsented
}) {
  return (
    <div
      className={`bundle-list_container ${
        apiBundles.length === 0 ? "hide_bundle_grid" : ""
      }`}
    >
      <div className="api-dir-pkg_api-main-header">{`Bundles (${count})`}</div>
      <Grid>
        <Row>
          {apiBundles.map((bundle, index) => (
            <Column
              l={5.7}
              m={5}
              xs={5}
              key={index}
              style={{ marginRight: "22px", marginBottom: "22px" }}
            >
              <BundleCard
                apiBundle={bundle}
                entity={entity}
                environmentURLs={environmentURLs}
                apiHomeOnClickHandlers={apiHomeOnClickHandlers}
                belongsTo={belongsTo}
                existingSolutionDetails={existingSolutionDetails}
                disableBuildNow={disableBuildNow}
                isMsaConsented={isMsaConsented}
              />
            </Column>
          ))}
        </Row>
      </Grid>
    </div>
  );
}

export default BundleList;
